import type { JSX } from "preact";

type ContainerProps = JSX.HTMLAttributes<HTMLDivElement> & {
  children: JSX.Element | JSX.Element[];
};

export function Container({ children, className = "", ...props }: ContainerProps) {
  return (
    <div
      className={`w-full max-w-md p-4 border-2 border-black dark:border-gray-100 bg-white dark:bg-gray-950 text-left text-gray-800 dark:text-gray-200 text-sm brutal-shadow ${className}`.trim()}
      {...props}
    >
      {children}
    </div>
  );
}
